const HandleOnClick = () => {
    window.open("https://drive.google.com/file/d/1fGbCicSELrReyNanrNUlBqjFIDWQzg9x/view?usp=share_link");
  }
  
  export default HandleOnClick;
  